import {
	Message,
	Loading,
	MessageBox
} from 'element-ui';
import $public from './public.js'
import md5 from 'js-md5';
import {
	getLodop
} from './LodopFuncs.js';
let http = "https";
let loading
export default {
	isLogin() {
		let usr = localStorage.getItem('token')
		if (usr == null) {
			return false;
		}
		return true;
	},
	fileToBase64(blob) {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.onload = e => {
				console.log(e, "图片数据");
				resolve(e.target.result);
			};
			// readAsDataURL
			fileReader.readAsDataURL(blob);
			fileReader.onerror = () => {
				reject(new Error("blobToBase64 error"));
			};
		});
	},
	// base64 格式          
	getBase64(file) {
		return new Promise(function(resolve, reject) {
			let reader = new FileReader();
			let imgResult = '';
			reader.readAsDataURL(file);
			reader.onload = function() {
				imgResult = reader.result
			};
			reader.onerror = function(error) {
				reject(error)
			};
			reader.onloadend = function() {
				resolve(imgResult)
			}
		})
	},
	dealImage(path, obj, callback) {
		var img = new Image();
		img.src = path;
		img.onload = function() {
			var that = this;
			// 默认按比例压缩
			var w = that.width,
				h = that.height,
				scale = w / h;
			w = obj.width || w;
			h = obj.height || w / scale;
			var quality = obj.quality || 0.7; // 默认图片质量为0.7
			//生成canvas
			var canvas = document.createElement("canvas");
			var ctx = canvas.getContext("2d");
			// 创建属性节点
			var anw = document.createAttribute("width");
			anw.nodeValue = w;
			var anh = document.createAttribute("height");
			anh.nodeValue = h;
			canvas.setAttributeNode(anw);
			canvas.setAttributeNode(anh);
			ctx.drawImage(that, 0, 0, w, h);
			// 图像质量
			if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
				quality = obj.quality;
			}
			// quality值越小，所绘制出的图像越模糊
			var base64 = canvas.toDataURL("image/jpeg", quality);
			// 回调函数返回base64的值
			callback(base64);
		};
	},
	goPage(url, param) {
		let p = '';
		for (let i in param) {
			p += '&' + i + '=' + param[i]
		}
		// this.$router.push(url + '?' + p.substring(1));
	},
	checkidcardformat(value) {
		let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
		return reg.test(value);
	},
	isPhone: phone => {
		if (!(/^1[3456789]\d{9}$/.test(phone))) {
			return false;
		}
		return true;
	},
	checkTel: tel => {
		if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(tel)) {
			return false;
		}
		return true;
	},
	isEnglish: value => {
		if (!/^[a-zA-Z\s]+$/.test(value)) {
			return false;
		}
		return true;
	},
	isNumber: value => {
		if (!/^[0-9]*$/.test(value)) {
			return false;
		}
		return true;
	},
	isNumAndEnglist: value => {
		if (!/^[\da-z]+$/i.test(value)) {
			return false;
		}
		return true;
	},
	loading(msg, div) {
		loading = Loading.service({
			lock: false,
			text: msg,
			spinner: 'el-icon-loading',
			//fullscreen:false,
			background: 'rgba(212, 212, 212, 0.7)',
			target: document.querySelector('.' + div)
		});
	},
	loading2(msg, div) {
		loading = Loading.service({
			lock: false,
			text: msg,
			spinner: 'el-icon-loading',
			//fullscreen:false,
			background: 'rgba(212, 212, 212, 0.7)',
			target: document.querySelector('#' + div)
		});
	},
	loadingclose() {
		if(loading!=undefined)
			loading.close();
	},
	//提示信息
	message(msg, type, time) {
		if (type == undefined) {
			type = 'success'
		}
		if (type == 1) { //成功标识
			type = 'success';
		} else if (type == 0) { //失败/错误标识
			type = 'error';
		} else if (type == 2) { //警告
			type = 'warning';
		}
		if (time == undefined)
			time = 1500;
		Message({
			message: msg,
			type: type,
			duration: time,
			center: true,
			offset: (window.innerHeight * 50) / 100
		});
	},
	alertmessage(msg) {
		MessageBox.alert(msg, '提示', {
			dangerouslyUseHTMLString: true
		});
	},
	//去特殊字符
	formatinput: value => {
		if (value != undefined) {
			var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？\r|\n]")
			var rs = "";
			for (var i = 0; i < value.length; i++) {
				rs = rs + value.substr(i, 1).replace(pattern, '');
			}
			return rs;
		} else
			return '';
	},
	formatdateday(str) {
		var strdate = "";
		var date = new Date();
		if (str != undefined)
			date = new Date(str);
		var year = date.getFullYear();
		var month = (date.getMonth() + 1);
		if (month < 10) {
			month = '0' + month;
		}
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		var min = date.getMilliseconds();
		strdate = year + '-' + month + '-' + day;
		return strdate;
	},
	//格式化日期，返回yyyy-MM-dd HH:mm:ss
	formatdate(str) {
		var strdate = "";
		var date = new Date();
		if (str != undefined)
			date = new Date(str);
		var year = date.getFullYear();
		var month = (date.getMonth() + 1);
		if (month < 10) {
			month = '0' + month;
		}
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		var hours = date.getHours();
		if (hours < 10) {
			hours = '0' + hours;
		}
		var minutes = date.getMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes;
		}
		var second = date.getSeconds();
		if (second < 10) {
			second = '0' + second;
		}
		var min = date.getMilliseconds();
		strdate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + second;
		return strdate;
	},
	//获取当前时间并增加指定时间
	getdate(addtype, value) {
		var date = new Date();
		if (addtype == 'YY') {
			date.setYear(date.getFullYear() + value);
		}
		if (addtype == 'MM') {
			date.setMonth(date.getMonth() + value);
		}
		if (addtype == 'DD') {
			date.setDate(date.getDate() + value);
		}
		if (addtype == 'HH') {
			date.setHours(date.getHours() + value);
		}
		if (addtype == 'mm') {
			date.setMinutes(date.getMinutes() + value);
		}
		return this.formatdate(date);
	},
	/**
	 * addtype--新增时间类型  YY--年  MM--月  DD--日  HH--小时 mm--分钟
	 * value--新增时间值，Int型
	 * datevalue--操作的时间，不传默认为当前时间
	 ***/
	addgetdate(addtype, value,datevalue) {
		var date = new Date();
		if(datevalue!=undefined)
			date = new Date(datevalue);
		if (addtype == 'YY') {
			date.setYear(date.getFullYear() + value);
		}
		if (addtype == 'MM') {
			date.setMonth(date.getMonth() + value);
		}
		if (addtype == 'DD') {
			date.setDate(date.getDate() + value);
		}
		if (addtype == 'HH') {
			date.setHours(date.getHours() + value);
		}
		if (addtype == 'mm') {
			date.setMinutes(date.getMinutes() + value);
		}
		//debugger
		if(value>0){
			date.setSeconds(Math.ceil(Math.random()*60));//秒针设置为随机数
		}
		return this.formatdate(date);
	},
	setgridstyle(currentcontrol, tableindex) {
		// setTimeout(()=> {
		// 	if(currentcontrol!=undefined){
		// 		if(currentcontrol.length>0){
		// 			currentcontrol[tableindex].$refs.tablegrid.doLayout();
		// 		}else{
		// 			if(currentcontrol.$refs!=undefined)
		// 				currentcontrol.$refs.tablegrid.doLayout();
		// 		}
		// 	}
		//  },300);
	},
	//检测打印控件是否已安装
	checkprintcontrol() {
		try {
			LODOP = getLodop();
			if (LODOP.VERSION) {
				return true;
			}
		} catch (err) {
			return false;
		}
	},
	//弹出下载打印控件的输入框
	opendowncontrol() {
		var html = "<el-row style=\"margin-top:10px;padding-left:30px;padding-top:20px;width:97%\">";
		html += "<el-col :span=\"24\">";
		html += "<a style=\"color:#29aadd;font-size:12pt; margin-left:10px;font-weight:bold\" href=\"" + http +
			"://dzmd.yunbangsoft.cn/打印控件.zip\">点击下载打印控件</a>";
		html += "</el-col></el-row>";
		MessageBox.alert(html, '下载控件', {
			dangerouslyUseHTMLString: true
		});
	},
	//获取本地打印机
	getlocalprinterstr() {
		if (this.checkprintcontrol()) {
			var options = "";
			var iCount = LODOP.GET_PRINTER_COUNT();
			if (iCount > 0) {
				for (var i = 0; i < iCount; i++) {
					options += LODOP.GET_PRINTER_NAME(i) + ",";
				}
			}
			if (options != "") {
				options = options.substring(0, options.length - 1);
			}
		} else {
			this.opendowncontrol();
		}
		return options;
	},
	//获取本地打印机列表
	getprinterlist() {
		var options = [{
			value: '-1',
			label: '默认打印机'
		}];
		if (this.checkprintcontrol()) {
			var iCount = LODOP.GET_PRINTER_COUNT();
			if (iCount > 0) {
				for (var i = 0; i < iCount; i++) {
					options.push({
						value: LODOP.GET_PRINTER_NAME(i),
						label: LODOP.GET_PRINTER_NAME(i)
					});
				}
			} else {
				options = [];
			}
		} else {
			this.opendowncontrol();
		}
		return options;
	},
	getprinterlistall() {
		var options = [];
		if (this.checkprintcontrol()) {
			var iCount = LODOP.GET_PRINTER_COUNT();
			if (iCount > 0) {
				for (var i = 0; i < iCount; i++) {
					options.push({
						value: LODOP.GET_PRINTER_NAME(i),
						label: LODOP.GET_PRINTER_NAME(i)
					});
				}
			} else {
				options = [];
			}
		} else {
			this.opendowncontrol();
		}
		return options;
	},
	//获取指定打印机纸张
	getpagesize(printer) {
		var options = [];
		if(printer=='默认打印机')
			printer=-1;
		var strResult = LODOP.GET_PAGESIZES_LIST(printer, "\n");
		if (strResult != '') {
			var list = strResult.split('\n');
			for (var i = 0; i < list.length; i++) {
				options.push({
					value: list[i],
					label: list[i]
				});
			}
		}
		return options;
	},
	//获取当前时间
	getcurrenttime() {
		var d = new Date();
		return this.formatdate();
	},
	datetotime(str){
	  let date = new Date(str);
	  let y = date.getFullYear()
	  let m = date.getMonth() + 1
	  m = m < 10 ? ('0' + m) : m
	  let d = date.getDate()
	  d = d < 10 ? ('0' + d) : d
	  let h=date.getHours();
	  h=h<10? ('0' + h) : h;
	  let mi=date.getMinutes();
	  mi=mi<10? ('0' + mi) : mi;
	  
	  const time =  y + '-' + m + '-' + d+' '+h+':'+mi;
	  return time;
	},
	datetotime_ss(str){
	  let date = new Date(str);
	  let y = date.getFullYear()
	  let m = date.getMonth() + 1
	  m = m < 10 ? ('0' + m) : m
	  let d = date.getDate()
	  d = d < 10 ? ('0' + d) : d
	  let h=date.getHours();
	  h=h<10? ('0' + h) : h;
	  let mi=date.getMinutes();
	  mi=mi<10? ('0' + mi) : mi;
	  let ss=date.getSeconds();
	  ss=ss<10? ('0' + ss) : ss;
	  const time =  y + '-' + m + '-' + d+' '+h+':'+mi+':'+ss;
	  return time;
	},
	//获取当前日期
	getcurrentday(str) {
		var strdate = "";
		var date = new Date();
		if (str != undefined)
			date = new Date(str);
		var year = date.getFullYear();
		var month = (date.getMonth() + 1);
		if (month < 10) {
			month = '0' + month;
		}
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		strdate = year + '-' + month + '-' + day;
		return strdate;
	},
	//地址联动
	addrlink(that, val, modelindex, i) {
		var country = "";
		//获取国家
		if (val.type != undefined) {
			val = i.value;
		}
		that.model1[modelindex].children.forEach(child => {
			if (child.colname.indexOf('country') > -1) {
				country = child.value;
			}
		});
		if (i.colevent == 'postcode') { //根据邮编输出省市
			if (country != '') {
				that.$apipost.get.GetBaseAddrByPostCode({
					postcode: val,
					country: country
				}).then(res => {
					if (res != '') {
						that.model1[modelindex].children.forEach(child => {
							for (var key in res.list[0]) {
								if (child.colname.indexOf(key) > -1) {
									child.value = res.list[0][key];
									break;
								}
							}
						});
					}
				});
			}
		}
		if (i.colevent == 'province' || i.colevent == 'city') {
			if (country != '') {
				var province = "";
				if (i.colevent == 'city') {
					//获取省份
					that.model1[modelindex].children.forEach(child => {
						if (child.colname.indexOf('province') > -1) {
							province = child.value;
						}
					});
				}
				var searchinfo = {
					country: country,
					province: province,
					searchkey: val,
					recol: i.colevent
				}
				that.$apipost.get.GetBaseAddr({
					searchinfo: JSON.stringify(searchinfo)
				}).then(res => {
					if (res != '') {
						i.colsource = res.list;
					}
				});
			}
		}
	},
	//单独地址模块使用地址自动联查
	addrlink_model(that, val, i) {
		var country = "";
		//获取国家
		if (val.type != undefined) {
			val = i.value;
		}
		that.setlist.forEach(child => {
			if (child.colname.indexOf('country') > -1) {
				country = child.value;
			}
		});
		if (i.colevent == 'postcode') { //根据邮编输出省市
			if (country != '') {
				that.$apipost.get.GetBaseAddrByPostCode({
					postcode: val,
					country: country
				}).then(res => {
					if (res != '') {
						that.setlist.forEach(child => {
							for (var key in res.list[0]) {
								if (child.colname.indexOf(key) > -1) {
									child.value = res.list[0][key];
									break;
								}
							}
						});
					}
				});
			}
		}
		if (i.colevent == 'province' || i.colevent == 'city') {
			if (country != '') {
				var province = "";
				if (i.colevent == 'city') {
					//获取省份
					that.setlist.forEach(child => {
						if (child.colname.indexOf('province') > -1) {
							province = child.value;
						}
					});
				}
				var searchinfo = {
					country: country,
					province: province,
					searchkey: val,
					recol: i.colevent
				}
				that.$apipost.get.GetBaseAddr({
					searchinfo: JSON.stringify(searchinfo)
				}).then(res => {
					if (res != '') {
						i.colsource = res.list;
					}
				});
			}
		}
	},
	//地址联动并回调
	addrlink_call(that, modelindex, i, cb) {
		var country = "";
		//获取国家
		that.model1[modelindex].children.forEach(child => {
			if (child.colname.indexOf('country') > -1) {
				country = child.value;
			}
		});
		if (i.colevent == 'province' || i.colevent == 'city') {
			if (country != '') {
				var province = "";
				if (i.colevent == 'city') {
					//获取省份
					that.model1[modelindex].children.forEach(child => {
						if (child.colname.indexOf('province') > -1) {
							province = child.value;
						}
					});
				}
				var searchinfo = {
					country: country,
					province: province,
					searchkey: i.value,
					recol: i.colevent
				}
				that.$apipost.get.GetBaseAddr({
					searchinfo: JSON.stringify(searchinfo)
				}).then(res => {
					if (res != '') {
						i.colsource = res.list;
						cb(res.list);
					}
				});
			}
		} else if (i.colevent == 'country') {
			that.$apipost.get.GetCountry({
				searchkey: i.value
			}).then(res => {
				if (res != '') {
					i.colsource = res.list;
					cb(res.list);
				}
			});
		}
	},
	//单独地址模块地址联动并回调
	addrlink_call_model(that, i, cb) {
		var country = "";
		//获取国家
		that.setlist.forEach(child => {
			if (child.colname.indexOf('country') > -1) {
				country = child.value;
			}
		});
		if (i.colevent == 'province' || i.colevent == 'city') {
			if (country != '') {
				var province = "";
				if (i.colevent == 'city') {
					//获取省份
					that.setlist.forEach(child => {
						if (child.colname.indexOf('province') > -1) {
							province = child.value;
						}
					});
				}
				var searchinfo = {
					country: country,
					province: province,
					searchkey: i.value,
					recol: i.colevent
				}
				that.$apipost.get.GetBaseAddr({
					searchinfo: JSON.stringify(searchinfo)
				}).then(res => {
					if (res != '') {
						i.colsource = res.list;
						cb(res.list);
					}
				});
			}
		} else if (i.colevent == 'country') {
			that.$apipost.get.GetCountry({
				searchkey: i.value
			}).then(res => {
				if (res != '') {
					i.colsource = res.list;
					cb(res.list);
				}
			});
		}
	},
	crmlist_call(that, i, cb){
		var paraminfo={
			searchkey:i.value,
			token:localStorage.getItem('token')
		}
		that.$apipost.get.GetCustomerItem({
			paraminfo: paraminfo
		}).then(res => {
			console.log('读取单位信息'+res);
			if (res != '') {
				if(res.state=='1'){
					i.colsource = res.list;
					cb(res.list);
				}
				else
				{
					i.colsource =[];
					cb([]);
				}
			}else
				{
					i.colsource =[];
					cb([]);
				}
		});
	},
	//文本框输入自动提示
	inputsuggestions_call(that, modelindex, i, cb) {
		if (i.colevent == 'email') {
			var list = [{
					showname: i.value + '@qq.com'
				},
				{
					showname: i.value + '@sina.com'
				},
				{
					showname: i.value + '@163.com'
				},
				{
					showname: i.value + '@gmail.com'
				}
			]
			i.colsource = list;
			cb(list);
		}
	},
	//自动下载文件
	downfile(that, filename, batch) {
		if (batch == undefined)
			batch = '';
		let link = document.createElement('a');
		link.style.display = 'none';
		link.href = that.$apiprototype.ApiServer + '/order/getfile?filename=' + escape(filename) + '&batch=' + batch+'&domain='+that.$apiprototype.WebServer;
		link.setAttribute('download', filename);
		document.body.appendChild(link);
		link.click();
		setTimeout(function(){
			loading.close();
		},2000);
	},
	DownFileByurl(url,filename){
		// setTimeout(function() {
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			link.target = '_blank';
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
		// }, 100);		
	},
	//浏览器打开文件
	OpenFile(that, labelurl) {
		var url = labelurl.split("★");
		url.forEach(e => {
			setTimeout(function() {
				if (e != '') {
					let link = document.createElement('a');
					link.style.display = 'none';
					link.href = e;
					link.target = '_blank';
					document.body.appendChild(link);
					link.click();
				}
			}, 100);
		});
	},
		//浏览器打开网址
	OpenUrl(that, labelurl) {
		var url = labelurl.split("★");
		url.forEach(e => {
			var newwin=window.open();
			setTimeout(function() {
				if (e != '') {
					newwin.location.href=e;
				}
			}, 200);
		});
	},
	getGuid() {
		function S4() {
			return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
		}
		return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
	},
	//判断是否为域名
	isdomain(domain) {
		var reg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
		domain = domain.replace('http://', '').replace('https://', '')
		return reg.test(domain);
	},
	//查询客户列表
	customerlink(that, search, type,col) {
		var paraminfo = {
			search: search,
			userid: localStorage.getItem("userid"),
			pageindex: 0,
			pagesize: 20,
			tab: 'tab1',
			l_mode: '客户管理'
		}
		if (type == 'page')
			that.customerlist = [];
		that.$apipost.get.GetCustomer({
			paraminfo: paraminfo
		}).then(res => {
			//debugger
			if (res != '') {
				if (type == 'page')
					that.customerlist = res.data;
				else
					col.colsource = res.data;
			}
		});
	},
	//获取下拉选项
	GetSelectData(that,l_mode,tab,search){
		return new Promise((resolve, reject) => {
			var paraminfo={
				l_mode:l_mode,
				search:search,
				tab:tab
			}
			//debugger
			//先获取筛选条件
			that.$apipost.get.AnalysisSearch({paraminfo:paraminfo}).then(re => {
				if(re.state=='1'){
					var sort=re.sort,filter=re.filter,listparam=re.listparam;
					if(sort==undefined)
						sort='';
					if(filter==undefined)
						filter='';
					if(listparam==undefined)
						listparam='';
					that.$apipost.get.CreateGrid({
					l_mode:l_mode,
					tab:tab,
					pageindex:0,
					showcol:'',
					pagesize:10,
					sort:sort,
					search:filter,
					listparam:listparam,
					iscount:false,
					userid:localStorage.getItem('userid')}).then(res => {
						resolve(res.data);
					}).catch((err) => {
						resolve([]);
					});
				}
				else
					resolve([]);
			}).catch((err) => {
				resolve([]);
			});
		});
	},
	//获取支付图标
	getpayicon(type) {
		if (type == '微信')
			return 'data:image/png;base64,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';
		if (type == '支付宝')
			return 'data:image/png;base64,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';
	},


	// //获取常用筛选条件
	// GetFilter(that,mode,type){
	// 	this.$apipost.get.GetFilter({l_mode:mode,type:type}).then(res => {
	// 		if (res.data!='') {
	// 			that.filterlist=res.data;
	// 		}
	// 	});
	// }
	//检测身份证格式，包含香港和台湾身份证验证
	checkidcardformat(idcard) {
		var socialNo = idcard;
		if (socialNo.length != 15 && socialNo.length != 18) {
			return this.IsTWIdcard(idcard) || this.IsHKID(idcard);
		}
		var area = {
			11: "北京",
			12: "天津",
			13: "河北",
			14: "山西",
			15: "内蒙古",
			21: "辽宁",
			22: "吉林",
			23: "黑龙江",
			31: "上海",
			32: "江苏",
			33: "浙江",
			34: "安徽",
			35: "福建",
			36: "江西",
			37: "山东",
			41: "河南",
			42: "湖北",
			43: "湖南",
			44: "广东",
			45: "广西",
			46: "海南",
			50: "重庆",
			51: "四川",
			52: "贵州",
			53: "云南",
			54: "西藏",
			61: "陕西",
			62: "甘肃",
			63: "青海",
			64: "宁夏",
			65: "新疆",
			71: "台湾",
			81: "香港",
			82: "澳门",
			83: "台湾",
			91: "国外"
		};
		if (area[parseInt(socialNo.substr(0, 2))] == null) {
			return false;
		}
		if (socialNo.length == 15) {
			pattern = /^\d{15}$/;
			if (pattern.exec(socialNo) == null) {
				return false;
			}
			var birth = parseInt("19" + socialNo.substr(6, 2));
			var month = socialNo.substr(8, 2);
			var day = parseInt(socialNo.substr(10, 2));
			switch (month) {
				case '01':
				case '03':
				case '05':
				case '07':
				case '08':
				case '10':
				case '12':
					if (day > 31) {
						return false;
					}
					break;
				case '04':
				case '06':
				case '09':
				case '11':
					if (day > 30) {
						return false;
					}
					break;
				case '02':
					if ((birth % 4 == 0 && birth % 100 != 0) || birth % 400 == 0) {
						if (day > 29) {
							return false;
						}
					} else {
						if (day > 28) {
							return false;
						}
					}
					break;
				default:
					return false;
			}
			var nowYear = new Date().getFullYear();
			if (nowYear - parseInt(birth) < 15 || nowYear - parseInt(birth) > 100) {
				return false;
			}
			return true;
		}
		var Wi = new Array(
			7, 9, 10, 5, 8, 4, 2, 1, 6,
			3, 7, 9, 10, 5, 8, 4, 2, 1
		);
		var lSum = 0;
		var nNum = 0;
		var nCheckSum = 0;
		for (var i = 0; i < 17; ++i) {
			if (socialNo.charAt(i) < '0' || socialNo.charAt(i) > '9') {
				return false;
			} else {
				nNum = socialNo.charAt(i) - '0';
			}
			lSum += nNum * Wi[i];
		}
		if (socialNo.charAt(17) == 'X' || socialNo.charAt(17) == 'x') {
			lSum += 10 * Wi[17];
		} else if (socialNo.charAt(17) < '0' || socialNo.charAt(17) > '9') {
			return false;
		} else {
			lSum += (socialNo.charAt(17) - '0') * Wi[17];
		}
		if ((lSum % 11) == 1) {
			return true;
		} else {
			return false;
		}
	},
	/**
	 * 台湾身份证效验
	 * @param {any} idcard
	 */
	IsTWIdcard(idcard) {
		if (/^[A-Z][1-2]\d{8}$/.test(idcard)) {
			var area = {
				'A': 10,
				'B': 11,
				'C': 12,
				'D': 13,
				'E': 14,
				'F': 15,
				'G': 16,
				'H': 17,
				'J': 18,
				'K': 19,
				'L': 20,
				'M': 21,
				'N': 22,
				'P': 23,
				'Q': 24,
				'R': 25,
				'S': 26,
				'T': 27,
				'U': 28,
				'V': 29,
				'X': 30,
				'Y': 31,
				'W': 32,
				'Z': 33,
				'I': 34,
				'O': 35
			};
			var idcard_array = new Array();

			idcard_array = idcard.split("");

			var jym = parseInt(area[idcard_array[0]] / 10) + 9 * (area[idcard_array[0]] % 10) + 8 * idcard_array[1] +
				7 * idcard_array[2] + 6 * idcard_array[3] + 5 * idcard_array[4] + 4 * idcard_array[5] + 3 *
				idcard_array[6] + 2 * idcard_array[7] + 1 * idcard_array[8];

			jym = (10 - jym % 10) % 10;
			if (idcard_array[9] == jym) {
				return true;
			}
		}

		return false;
	},
	/**
	 * 香港身份证效验
	 * @param {any} str
	 */
	IsHKID(str) {
		str = str.replace("（", "(").replace("）", ")");
		var strValidChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
		// basic check length
		if (str.length < 8)
			return false;
		// handling bracket
		if (str.charAt(str.length - 3) == '(' && str.charAt(str.length - 1) == ')')
			str = str.substring(0, str.length - 3) + str.charAt(str.length - 2);
		// convert to upper case
		str = str.toUpperCase();
		// regular expression to check pattern and split
		var hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;
		var matchArray = str.match(hkidPat);
		// not match, return false
		if (matchArray == null)
			return false;
		// the character part, numeric part and check digit part
		var charPart = matchArray[1];
		var numPart = matchArray[2];
		var checkDigit = matchArray[3];
		// calculate the checksum for character part
		var checkSum = 0;
		if (charPart.length == 2) {
			checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
			checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
		} else {
			checkSum += 9 * 36;
			checkSum += 8 * (10 + strValidChars.indexOf(charPart));
		}
		// calculate the checksum for numeric part
		for (var i = 0, j = 7; i < numPart.length; i++, j--)
			checkSum += j * numPart.charAt(i);
		// verify the check digit
		var remaining = checkSum % 11;
		var verify = remaining == 0 ? 0 : 11 - remaining;
		return verify == checkDigit || (verify == 10 && checkDigit == 'A');
	},
	//验证电话号码格式
	checktel(tel) {
		if (!this.IsTelePhoneNumber(tel) && !this.IsTelePhoneNumber2(tel) && !this.IsMobilePhoneNumber(tel)) {
			return false;
		} else {
			return true;
		}
	},
	//验证固定电话号码 [3位或4位区号；区号可以用小括号括起来；区号可以省略；区号与本地号间可以用减号或空格隔开；可以有3位数的分机号，分机号前要加减号]  
	IsTelePhoneNumber(input) {
		//var regex = /^(((0\d2|0\d{2})[- ]?)?\d{8}|((0\d3|0\d{3})[- ]?)?\d{7})(-\d{3})?$/;
		input = input.replace(/-/g, "");
		if (!isNaN(input)) {
			if (input.substring(0, 1) == "1") {
				if (input.length != 11) {
					return false;
				} else {
					return true;
				}
			}
			if (input.substring(0, 3) != "400" && input.substring(0, 3) != "800" && input.replace(/-/g, "").replace(
					/\"/g, "").replace(/ /g, "").length < 11) {
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	},
	//验证是否为800 或者 400 固话
	IsTelePhoneNumber2(input) {
		input = input.replace(/-/g, "");
		var regex = /^-?\d+$/;
		if (input.substring(0, 3) == "400" || input.substring(0, 3) == "800") {
			if (input.length == 10 && input.match(regex)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	//验证手机号码 [可匹配"(+86)013325656352"，括号可以省略，+号可以省略，(+86)可以省略，11位手机号前的0可以省略；11位手机号第二位数可以是1、2、3、4、5、7、8、9、0中的任意一个]  
	IsMobilePhoneNumber(input) {
		input = input.replace(/-/g, "");
		var regex = /^((\+)?86|((\+)?86)?)0?1[1234567890]\d{9}$/;
		if (input.match(regex)) {
			return true;
		} else {
			return false;
		}
	},
	//发送微信提醒
	//pkval--不同业务代表不同的意思，订单中代表订单号，在用户信息中代表用户账号，根据实际界面的需求来传的
	//sendrequest={
	//msgid:--消息模板id,
	//info:--消息内容json
	//pkval:--关键词值，用于获取接收人
	//type:--获取接收人方式-,即根据不同类型去不同的业务表查找接收人
	//showerror:--流程报错是否需要弹出提示  true/false
	//}
	SendMessage(sendrequest, that) {
		that.$apipost.get.GetEnabledParam({
			paramname: "是否启用公众号"
		}).then(res => {
			if (res.state == '1') {
				//获取接收人
				that.$apipost.get.GetMsgRecevier({
					pkval: sendrequest.pkval,
					type: sendrequest.type,
					msgid: sendrequest.msgid,
				}).then(Rec => {
					if (Rec.state == "1") {
						var paraminfo = {
							id: sendrequest.msgid,
							info: sendrequest.info,
							type:'wx'
						}
						that.$apipost.get.ComposeMsgTemp({
							paraminfo: paraminfo
						}).then(temp => {
							if (temp.state == '1') {
								that.$apipost.post.SendMsg({
									template: temp.template,
									xcxtemplate: temp.xcxurl,
									recevier: Rec.recevier,
									msgid: sendrequest.msgid
								}).then(sendmsg => {
									if (sendmsg.state == '1') {

									}
								});
							} else {
								if (sendrequest.showerror)
									this.message('无模板内容', 0);
							}
						});
					} else {
						if (sendrequest.showerror)
							this.message('无信息接收人', 0);
					}
				});
			} else {
				if (sendrequest.showerror)
					this.message('公众号未启用', 0);
			}
		});
	},
	//发送邮箱消息
	//pkval--不同业务代表不同的意思，订单中代表订单号，在用户信息中代表用户账号，根据实际界面的需求来传的
	//sendrequest={
	//msgid:--消息模板id,
	//info:--消息内容json
	//pkval:--关键词值，用于获取接收人
	//type:--获取接收人方式-,即根据不同类型去不同的业务表查找接收人
	//showerror:--流程报错是否需要弹出提示  true/false
	//}
	SendEmailMsg(sendrequest, that){
		//获取接收人
		that.$apipost.get.GetEmailRecevier({
			pkval: sendrequest.pkval,
			type: sendrequest.type,
			msgid: sendrequest.msgid
		}).then(Rec => {
			//console.log('info',JSON.stringify(sendrequest.info));
			//console.log('info encode',encodeURIComponent(JSON.stringify(sendrequest.info)));
			if (Rec.state == "1") {
				var paraminfo = {
					id: sendrequest.msgid,
					info:encodeURIComponent(JSON.stringify(sendrequest.info)),
					type:'email',
					userid:Rec.u_userid
				}
				that.$apipost.get.ComposeMsgTemp({
					paraminfo: paraminfo
				}).then(temp => {
					debugger
					if (temp.state == '1') {
						that.$apipost.post.SendEmailMsg({
							template: temp.template,
							title:temp.title,
							recevier: Rec.recevier,
							msgid: sendrequest.msgid,
							ishtml:temp.ishtml
						}).then(sendmsg => {
							if (sendmsg.state == '1') {

							}
						});
					} else {
						if (sendrequest.showerror)
							this.message('无模板内容', 0);
					}
				});
			} else {
				if (sendrequest.showerror)
					this.message('无信息接收人', 0);
			}
		});
	},
	//语音读消息
	ReadMsg(msg) {
		if (this.checkprintcontrol()) {
			LODOP.FORMAT('VOICE:3;100', msg);
		}
	},
	CompareJson(objA, objB, flag) {
		//var that=this;
		for (var key in objA) {
			if (!flag) //跳出整个循环
				break;
			if (!objB.hasOwnProperty(key)) {
				flag = false;
				break;
			}
			if (!this.isArray(objA[key])) { //子级不是数组时,比较属性值
				if (objB[key] != objA[key]) {
					flag = false;
					break;
				}
			} else {
				if (!this.isArray(objB[key])) {
					flag = false;
					break;
				}
				var oA = objA[key],
					oB = objB[key];
				if (oA.length != oB.length) {
					flag = false;
					break;
				}
				for (var k in oA) {
					if (!flag) //这里跳出循环是为了不让递归继续
						break;
					flag = this.CompareJson(oA[k], oB[k], flag);
				}
			}
		}
		return flag;
	},
	isObj(object) {
		return object && typeof(object) == 'object' && Object.prototype.toString.call(object).toLowerCase() ==
			"[object object]";
	},
	isArray(object) {
		return object && typeof(object) == 'object' && object.constructor == Array;
	},
	copyJSON(text) {
		let target = document.createElement('textarea') //创建input节点
		target.value = text // 给input的value赋值
		document.body.appendChild(target) // 向页面插入input节点
		target.select() // 选中input
		try {
			document.execCommand('Copy') // 执行浏览器复制命令
			//this.message('复制成功',1);
			//console.log('单号复制成功')
		} catch {
			console.log('复制失败')
		}
	},
	//订单转换表
	ChangeOrderState(that,p_pkval,batch,targetstate){
		that.$apipost.post.ChangeOrderState({ p_pkval: p_pkval, batch:batch,targetstate:targetstate}).then(res => {
			if(res.state=='0'){
				this.ChangeOrderState(that,p_pkval,batch,targetstate);
			}
		}).catch(e=>{
			this.ChangeOrderState(that,p_pkval,batch,targetstate);
		});
	},
	GetWlcode(that,type){
		that.wlcodelist=[];
		return new Promise((resolve, reject) => {
			that.$apipost.get.GetWlcode({type:type}).then(res => {
				if(res.list!=undefined)
					resolve({state:1,list:res.list});
				else
					resolve({state:0});
			}).catch(e=>{
				resolve({state:0});
			});
		});
	},
	//订单退款
	OrderRefund(that,isdelorder,pkval){
		//debugger
		var _this=this;
		var paraminfo={
			pkval:pkval,
			handleraccount: localStorage.getItem('u_account'),
			userid:localStorage.getItem('userid')
		}
		_this.loading('正在退款');
		that.$apipost.post.RefundOrder({ paraminfo: paraminfo}).then(res => {
			//debugger
			_this.loadingclose();
			if (res.state == '1') {
				_this.message('退款成功', 1);
				if(isdelorder){
					_this.OrderRollback(pkval);
				}
			} 
			else if(res.state=="2"){
				_this.message(res.message, 0);
				that.refreshgrid(true);
				if(res.filename!=undefined)
					_this.downfile(that,res.filename);
			}
			else {
				if(res.message!='')
					_this.message(res.message, 0);
				else
					_this.message('退款失败', 0);
			}
		});
	},
	OrderRollback(that,pkval,p_batch,batch){
		if(p_batch==undefined)
			p_batch='';
		if(batch==undefined)
			batch='';	
		that.$apipost.post.RollBack_Order({ pkval:pkval, p_batch:p_batch, batch:batch, isdeltemp: 1 }).then(resmsg => {
			that.p_pkval='';
			if (that.$parent.p_pkval != undefined)
				that.$parent.p_pkval ='';
			else
				that.$parent.$parent.p_pkval = '';
		});
	},
	GetBaojiaNo(that){
		return new Promise((resolve, reject) => {
			that.$apipost.get.GetBaojiaNo().then(res => {
				if(res.list!=undefined)
					resolve({state:1,list:res.list});
				else
					resolve({state:0});
			}).catch(e=>{
				resolve({state:0});
			});
		});
	},
	//转换系统内的字段为界面配置字段
	TransOrderInfo(importcol,that){
		//debugger
		var _this=this;
		if(that.orderinfo!=''){
			var orderinfo=JSON.parse(JSON.stringify(that.orderinfo));
			var importcol=JSON.parse(importcol);
			importcol.forEach(e=>{
				for(var info in orderinfo){
					if(_this.isObj(orderinfo[info])&&e.groupBy){
						for(var s in orderinfo[info]){
							var col=e.fields.filter(function(f){
								return f.bizname==s&&f.bizname!=f.tempname;
							});
							if(col.length>0){
								orderinfo[info][col[0].tempname]=orderinfo[info][s];
								//delete orderinfo[info][s];
							}
						}
					}
					else if(_this.isArray(orderinfo[info])&&!e.groupBy){
						orderinfo[info].forEach(r=>{
							//debugger
							for(var s in r){
								var col=e.fields.filter(function(f){
									return f.bizname==s&&f.bizname!=f.tempname;
								});
								if(col.length>0){
									r[col[0].tempname]=r[s];
									//delete r[s];
								}
							}
						});
					}
					else{
						var col=e.fields.filter(function(f){
							return f.bizname==info&&f.bizname!=f.tempname;
						});
						if(col.length>0){
							orderinfo[col[0].tempname]=orderinfo[info];
							//delete orderinfo[info];
						}
					}
				}
			});
			return orderinfo;
		}
	},
	//读取界面填写值，组成实体类
	getOrderinfo(setlistdata,pkval,that,orderinfoBL){
		var _this=this;
		var orderinfo={};
		if(orderinfoBL!=undefined)
			orderinfo=orderinfoBL;
		var istrue=true;
		var setlist=setlistdata.setlist;
		if(setlistdata.pageset!=undefined)
			setlist=setlistdata.pageset[0].setlist;
		for(var i=0;i<setlist.length;i++){
			if(setlist[i].combox!=undefined){
				if(setlist[i].combox.length>0){
					if(setlist[i].combox[0].controlcombox!=undefined){
						var comboxlist=[];
						for(var s=0;s<setlist[i].combox.length;s++){
							var comboxvalue='';	//debugger
							var controlcombox=setlist[i].combox[s].controlcombox;
							for(var c=0;c<controlcombox.length;c++){
								istrue=_this.CheckNull(controlcombox[c],that,setlist[i].showname);
								if(istrue){
									if(controlcombox[c].coltype=='float'){
										if(controlcombox[c].value=="")
											controlcombox[c].value="0";
										comboxvalue+='"'+controlcombox[c].colname+'":"'+controlcombox[c].value+'",';
									}else
										comboxvalue+='"'+controlcombox[c].colname+'":"'+controlcombox[c].value+'",';
								}
								else
									break;
							}
							if(comboxvalue!=''){
								comboxvalue=comboxvalue.substring(0,comboxvalue.length-1);
								comboxvalue='{'+comboxvalue+'}';
								comboxlist.push(JSON.parse(comboxvalue));
							}
						}
						//debugger
						if(comboxlist.length>0)
							orderinfo[setlist[i].colname]=JSON.stringify(comboxlist);
						else
							orderinfo[setlist[i].colname]='';
					}
					else{
						for(var s=0;s<setlist[i].combox.length;s++){
							istrue=_this.CheckNull(setlist[i].combox[s],that,setlist[i].showname);
							if(istrue){
								if(setlist[i].combox[s].coltype=='float'){
									orderinfo[setlist[i].combox[s].colname]=setlist[i].combox[s].value==''?'0':setlist[i].combox[s].value;
								}else
									orderinfo[setlist[i].combox[s].colname]=setlist[i].combox[s].value;
							}
							else
								break;
						}
					}
				}
				
			}else{
				if(setlist[i].controltype=='table'){
					//debugger
					var list=setlist[i][setlist[i].colkey];
					if(list!=undefined){
						var rows=[];
						for(var t=0;t<list.length;t++){
							var table=setlist[i].table;
							if(!_this.RowIsEmpty(list[t],table)){
								for(var s=0;s<table.length;s++){
									//debugger
									if(table[s].type=='date'&&list[t][table[s].field]!=''&&list[t][table[s].field]!=undefined)
										list[t][table[s].field]=this.formatdateday(list[t][table[s].field]);
										
									istrue=_this.CheckTableNull(list[t],table[s],that,(parseInt(t)+1));
									if(!istrue)
										break;
								}
								if(!istrue)
									break;
								else
									rows.push(list[t]);
							}
						}
						if(istrue){
							if(orderinfo[setlist[i].colkey]!=undefined){
								if(orderinfo[setlist[i].colkey].length>0)
									orderinfo[setlist[i].colkey]=orderinfo[setlist[i].colkey].concat(rows);
								else
									orderinfo[setlist[i].colkey]=rows;
							}
							else
								orderinfo[setlist[i].colkey]=rows;
						}
					}
				}else{
					if(_this.isArray(setlist[i].value))
					{
						if(_this.isObj(setlist[i].value[0]))
							orderinfo[setlist[i].colname]=JSON.stringify(setlist[i].value);
						else
							orderinfo[setlist[i].colname]=setlist[i].value.join(',');
					}
					else{
						istrue=_this.CheckNull(setlist[i],that);
						if(istrue){
							if(setlist[i].coltype=='float'){
								if(setlist[i].value=='')
									orderinfo[setlist[i].colname]="0";
								else
									orderinfo[setlist[i].colname]=setlist[i].value;
							}else
								orderinfo[setlist[i].colname]=setlist[i].value;
						}
					}
				}
			}
			if(!istrue)
				break;
		}
		if(!istrue)
			orderinfo='';
		return orderinfo;
	},
	CheckNull(item,that,showname){
		 var istrue=true;
		 var _this=this;
		if(item.ishidden=='False'&&item.isnull=='False'){
			if(item.value.toString().trim()=='')
			{
				istrue=false;
				if(item.showname=='')
					_this.message(that.$lang.label.public.pleasewrite+showname,'0');
				else
					_this.message(that.$lang.label.public.pleasewrite+item.showname,'0');
			}
			if(istrue){
				if(item.coltype=='float')
				{
					if(isNaN(Number(item.value.toString().trim())))
					{
						istrue=false;
						if(item.showname=='')
							_this.message(showname+' '+that.$lang.label.public.pleasewritenumber,'0');
						else
							_this.message(item.showname+' '+that.$lang.label.public.pleasewritenumber,'0');
					}
				}
			}
		}
		return istrue;
	},
	CheckTableNull(row,colitem,that,index){
		var istrue=true;
		if(colitem.colshow=='1'&&colitem.isnull=='False'){
			if(row[colitem.field]!=undefined){
				if(row[colitem.field].toString().trim()=='')
				{
					istrue=false;
					this.message(that.$lang.label.public.no+index+that.$lang.label.public.row+colitem.title+that.$lang.label.public.notallowempty,'0');
				}
			}
		}
		return istrue;
	},
	//判断行是否都为空
	RowIsEmpty(row,cols){
		var isdata=true;
		cols.forEach(e=>{
			if(row[e.field]!=undefined){
				if(row[e.field].toString().trim()!='')
					isdata=false;
			}
		});
		return isdata;
	},
	GetCustomerInfo(e,that){
		var _this=this;
		var paraminfo=e;
		return new Promise((resolve, reject) => {
			that.$apipost.get.GetCustomerInfo({paraminfo:paraminfo}).then(res => {
				resolve(res);				
			}).catch(e=>{
				resolve({state:0});
			});
		});
	},
	CreateCopyContent(paraminfo,that){
		var _this=this;
		this.loading(that.$lang.label.public.generating, this.divclass);
		that.$apipost.post.CreateCopyContent({ paraminfo: paraminfo }).then(res => {
			_this.loadingclose();
			if (res.state == '1'){
				_this.copyJSON(res.value);
				_this.message(that.$lang.label.public.generatingsuccess, "1");
			}
			else
				_this.message(res.message, "0");
		});
	},
	CreateErrorFile(that,batch){
		var _this=this;
		that.$apipost.get.CreateErrorFile({batch:batch}).then(res => {
			if(res.localfilename!=undefined)
				_this.downfile(that,res.localfilename,batch);
		});
	},
	setPwd(code) {
		return md5(code);
	    // var c = String.fromCharCode(code.charCodeAt(0) + code.length);
	    // for (var i = 1; i < code.length; i++) {
	    //     c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
	    // }
	    // return encodeURIComponent(c);
	},
	createUniqueId(n) {
	      n = 1; // 生成一个唯一id，包含数字和字母
	      var random = function() {
	        // 生成10-12位不等的字符串
	        return Number(
	          Math.random()
	            .toString()
	            .substr(2)
	        ).toString(36); // 转换成十六进制
	      };
	      var arr = [];
	      function createId() {
	        var num = random();
	        var _bool = false;
	        arr.forEach(v => {
	          if (v === num) _bool = true;
	        });
	        if (_bool) {
	          createId();
	        } else {
	          arr.push(num);
	        }
	      }
	      var i = 0;
	      while (i < n) {
	        createId();
	        i++;
	      }
	     // this.uniqueId = arr[0]; // 将生成的转为我们需要的字符串并赋值
	      return arr[0];
	    },
		setgridcol(colset) {
			var cols = '';
			colset.forEach(e => {
				if (e.type != 'template'&&e.field!='checkbox') {
					cols += '"' + e.field + '":"",';
				}
			});
			if(cols!="")
				cols=cols.substring(0,cols.length-1);
			cols = '[{' + cols + '}]';
			return JSON.parse(cols);		
		}
	
}
